// Device state and config values come wrapped: the tenant API sends {ts, value}
// (older shapes and the test proxy {v}). unwrap returns the bare value.
export function unwrap(v: unknown): unknown {
  if (v && typeof v === "object") {
    if ("value" in (v as object)) return (v as { value: unknown }).value;
    if ("v" in (v as object)) return (v as { v: unknown }).v;
  }
  return v;
}
/** the VST reports its intervals as configuration (config.values), older data had them in state */
export const intervalOf = (d: { config?: { values?: Record<string, unknown> } | null; state?: Record<string, unknown> | null }, k: "sample_interval_s" | "tx_interval_s") =>
  Number(unwrap(d.config?.values?.[k]) ?? unwrap(d.state?.[k]) ?? 0) || 0;
